/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */ 

document.addEventListener("DOMContentLoaded", function() {
  $('body').on('mouseover','.quick-form__variant', function(e) {
    var itemQty = $(this).find('.SizeSwatch__Radio').attr('data-variant-qty') * 1;
    var inventory_policy = $(this).find('.SizeSwatch__Radio').attr('data-inventory_policy');
    var isAvailable = $(this).find('.SizeSwatch__Radio').attr('data-available'); 
    var parentEl = $(this).closest('.quick-form');
    var variantMessageEl = parentEl.find('.quick-form__variant-message');
    var variantMessage = '';
    if(itemQty == 0 && inventory_policy != 'continue') {
      variantMessage =  window.languages.out_of_stock;
    } else if(itemQty == 2) {
      variantMessage =  window.languages.only_2_pieces;
    } else if(itemQty == 1) {
      variantMessage =  window.languages.only_1_piece;
    } else {
      if(isAvailable == 'true') {
        variantMessage =  window.languages.in_stock;
      } else {
        variantMessage =  window.languages.out_of_stock;
      }
    }
    variantMessageEl.html(variantMessage);
  }); 
  $('body').on('mouseleave','.quick-form__variant', function(e) {
    var parentEl = $(this).closest('.quick-form');
    var isCheckedInput = $(this).find('[type="radio"]:checked');
    if(isCheckedInput.length == 0) {
      var variantMessageEl = parentEl.find('.quick-form__variant-message');
      variantMessageEl.html(window.languages.select_a_size);
    }
  });
  $('body').on('click','.quick-form__variant', function(e) {
    var parentEl = $(this).closest('.quick-form');
    var quick_add_hidden__form = parentEl.find('.quick_add_hidden__form');
    var main_select = quick_add_hidden__form.find('.main_select');
    var ProductForm__AddToCart  = quick_add_hidden__form.find('.ProductForm__AddToCart');

    var formSwatchInput = $(this).find('[type="radio"]:checked');
    var variantId = formSwatchInput.attr('data-variant-id');
    var isAvailable = formSwatchInput.attr('data-available'); 


    if(isAvailable == 'true') {
      main_select.val(variantId);
      console.log(ProductForm__AddToCart);
      
      ProductForm__AddToCart[0].dispatchEvent(new Event('click', { bubbles: true }));
      formSwatchInput.prop('checked',false);
      formSwatchInput.removeAttr('checked');
    }
  });

  $('body').on('click','.open_quick_modal', function(e) {
    e.preventDefault();
    $('body').addClass('active_quick_modal');
    var quick_add_modal = $(this).closest('.ProductItem').next('.quick_add_modal'); 
    quick_add_modal.addClass('active');
  });

  $('body').on('click','.close_quick_add_modal', function(e) {
    e.preventDefault();
    $('body').removeClass('active_quick_modal');
    $(this).closest('.quick_add_modal').removeClass('active');
//     setTimeout(function() {
//       $(this).closest('.quick_add_modal').remove();
//     },500);
  });

  $('body').on('change','.ProductItem__MainSelect', function(e) {
    e.preventDefault();

    var val = $(this).val();
    var submitFormBtn = $(this).closest('form').find('.ProductForm__AddToCart');
    var form_error = $(this).closest('form').find('.slidecart-form-error');
    if(form_error.length) {
      form_error.remove();
    }

    var activeOption = $(this).find('option:selected');
    var isAvailable = activeOption.attr('data-variant-available');
    if(isAvailable == 'true') {
      console.log(submitFormBtn);
      
      submitFormBtn.trigger('click');
    } else {
      var form = $(this).closest('form');
      form.append('<div class="error slidecart-form-error">' + window.languages.soldout_grid_text + '</div>');
    }
  });

  $('body').on('change','.quick_add_modal .ProductForm__Option [type="radio"]', function(e) {

    var itemQty = $(this).attr('data-variant-qty') * 1;
    var inventory_policy = $(this).attr('data-inventory_policy');
    var isAvailable = $(this).attr('data-available'); 
    var parentEl = $(this).closest('.ProductFormWrapper');
    var variantMessageEl = parentEl.find('.mobile-quick-form__variant-message');
    var variantMessage = '';
    if(itemQty == 0 && inventory_quantity != 'continue') {
      variantMessage =  window.languages.out_of_stock;
    } else if(itemQty == 2) {
      variantMessage =  window.languages.only_2_pieces;
    } else if(itemQty == 1) {
      variantMessage =  window.languages.only_1_piece;
    } else {
      if(isAvailable == 'true') {
        variantMessage =  window.languages.in_stock;
      } else {
        variantMessage =  window.languages.out_of_stock;
      }
    }
    variantMessageEl.html(variantMessage);

  });

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
          dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    var value = '';

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
    }

    if (formatString.indexOf('with_comma_separator') !== -1) {
      return formatString.replace(placeholderRegex, value).replace(',00', '');
    } else {
      return formatString.replace(placeholderRegex, value).replace('.00', '');
    }
  }

  $('body').on('change','.quick_add_modal .main_select', function(e) {

    var self = $(this);

    var quick_add_modal = self.closest('.quick_add_modal');

    var addToCartButton = quick_add_modal.find('.ProductForm__AddToCart')[0];
    var default_price = self.attr('data-default_price');

    var activeOption = self.find("option:selected");

    var price  = activeOption.attr('data-variant_price');
    var compare_at_price = activeOption.attr('data-variant_compare_at_price');
    var variant_image = activeOption.attr('data-variant_image');
    var isDisabled = activeOption.attr('disabled');


    if(default_price != price) {
      var productMetaPrices = quick_add_modal.find('.ProductMeta__PriceList');
      productMetaPrices.hide();
      productMetaPrices[0].innerHTML = '';

      if (compare_at_price > price) {
        productMetaPrices[0].innerHTML += '<span class="ProductMeta__Price Price Price--highlight Text--subdued u-h4" data-money-convertible>' + formatMoney(price, window.theme.moneyFormat) + '</span>';
        productMetaPrices[0].innerHTML += '<span class="ProductMeta__Price Price Price--compareAt Text--subdued u-h4" data-money-convertible>' + formatMoney(compare_at_price, window.theme.moneyFormat) + '</span>';
      } else {
        productMetaPrices[0].innerHTML += '<span class="ProductMeta__Price Price Text--subdued u-h4" data-money-convertible>' + formatMoney(price, window.theme.moneyFormat) + '</span>';
      }

      productMetaPrices.show();
      self.attr('data-default_price', price);

    }
    if(variant_image.length) {
      var item_imageElem = quick_add_modal.find('.item_image img');
      item_imageElem.attr('src',variant_image);
    }
    if(isDisabled != undefined ) {
      addToCartButton.setAttribute('disabled', 'disabled');
      addToCartButton.classList.add('Button--secondary');
      addToCartButton.removeAttribute('data-action');
      addToCartButton.innerHTML = window.languages.productFormSoldOut;


    } else {
      addToCartButton.removeAttribute('disabled');
      addToCartButton.classList.add(addToCartButton.getAttribute('data-use-primary-button') === 'true' ? 'Button--primary' : 'Button--secondary');
      addToCartButton.setAttribute('data-action', 'add-to-cart');
      addToCartButton.innerHTML = '<span>' + window.languages.productFormAddToCart + '</span>';


    }

  });

  $('body').on('click', function(e) {
    var el = e.target;
    if($(el).hasClass('active_quick_modal')) {
      $(el).removeClass('active_quick_modal');
      $('.quick_add_modal').removeClass('active');
    }
  });

  $('body').on('change','.product_option_dropdown', function(e) {
    e.preventDefault();

    var form =  $(this).closest('form');
    var main_select = form.find('.ProductItem__MainSelect');
    var active_options = '';
    var emptySelect = false;

    form.find('.product_option_dropdown').each(function () {
      var val = $(this).val();

      if(val.length > 0) {
        active_options = active_options + val + " / ";
      } else {
        emptySelect = true;
      }
    });

    if(emptySelect == false) {
      active_options = active_options.slice(0,-3);

      main_select.find('option').each(function () {
        var optionVal = $(this).text();
        if(optionVal == active_options) {
          var val = $(this).val();
          main_select.val(val);
          
          console.log(main_select);
          main_select.trigger('change');
        } 
      }); 
    }
  });

  var colour_products_carouselEl = $('.colour_products_carousel');
  if(colour_products_carouselEl.length) {
    colour_products_carouselEl.flickity({
      wrapAround: true,
      cellAlign:'center',
      pageDots: true,
      prevNextButtons: true,
      arrowShape: {x0: 20, x1: 60, y1: 40, x2: 60, y2: 35, x3: 25}
    });
    $('.colour_products_info_carousel').flickity({
      asNavFor: '.colour_products_carousel',
      draggable : false,
      pageDots: false,
      fade: true,
      prevNextButtons:false
    });
  }

  $('body').on('click', '.SelectModelBtn', function(e) {
    e.preventDefault();
    var modalParent = $(this).closest('.modal-colour_products');
    var activeSlide = modalParent.find('.colour_products_carousel .colour_product.is-selected');
    console.log(activeSlide);

    var Modal__CloseBtn = modalParent.find('.Modal__Close');
    if(activeSlide.length) {
      var url = activeSlide.attr('data-product-url');
      if(activeSlide.hasClass('main_product') == false) {
        window.location.href = url;
      } else {
        Modal__CloseBtn[0].dispatchEvent(new Event('click', { bubbles: true }));
      }
    }
  });

  document.addEventListener('product:added', function(event) {
    if( $('.quick_add_modal').length) {
      $('body').removeClass('active_quick_modal');
      $('.quick_add_modal').removeClass('active');
    }
  });

});